<section class="cmn-innerpage-wrapper">
  <div class="head">
    <h1>Badges</h1>
    <div class="head-div">
      <div class="search-wrapper">
        <input type="text" class="cmn-header-search" placeholder="Search Badges" (input)="onSearch($event)" />
      </div>
      <button *appHasPermission="'ADD_BADGE'" (click)="onAddBadge()" class="cmn-add-btn">
        <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> Add Badge
      </button>
    </div>
  </div>
  <div class="itemListWrapper" *ngIf="!loading">
    <div class="itemWrapper" *ngFor="let badge of badgeList">
      <div class="story-img-wrapper">
        <img [src]="badge.imgUrl || '../../../assets/images/placeHolderImage.jpg'" alt="badge-img"
          (error)="onImageError($event)" />
      </div>
      <h3 class="cmn-list-title" title="{{ getTranslationName(badge) }}">
        {{ truncateTitle(getTranslationName(badge), 10) }}
      </h3>
      <div class="action-Container">
        <div class="action-wrapper">
          <div *appHasPermission="'UPDATE_BADGE'" (click)="onEditBadge(badge.id)" class="iconWrapper">
            <img src="../../../assets/images/icons/icon-edit.svg" alt="" />
          </div>
          <div *appHasPermission="'DELETE_BADGE'" (click)="onDeleteBadge(badge.id)" class="iconWrapper">
            <img src="../../../assets/images/icons/icon-delete.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="noData">
    <app-no-data-component></app-no-data-component>
  </div>
  <app-content-loader [visible]="loading"></app-content-loader>
</section>
